// Keep only the fields the operator edited when reviewing a newer version.
export const rebaseDealDraft = (original, draft, current) => {
  const merged = { ...current };
  Object.keys(draft).forEach(key => {
    if (JSON.stringify(original[key]) !== JSON.stringify(draft[key])) {
      merged[key] = draft[key];
    }
  });
  return merged;
};
